// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout_gEFm6"};